var _title, _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisualizationSelectionPivotTable = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 48 48",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icon / Visualization Selection / Pivot table / Default")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Visualization-Selection-/-Pivot-table-/-Default"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Bounding-box",
  x: 0,
  y: 0,
  width: 48,
  height: 48
}), /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1 0h46a1 1 0 0 1 1 1v46a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1m17 38h13v8H18zm15 0h13v8H33zM18 28h13v8H18zm15 0h13v8H33zM18 18h13v8H18zm15 0h13v8H33z",
  id: "Table",
  fill: "#81848F"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Path",
  fill: "#C0C1C7",
  x: 2,
  y: 8,
  width: 14,
  height: 38
}), /*#__PURE__*/React.createElement("rect", {
  id: "Path",
  fill: "#C0C1C7",
  x: 18,
  y: 8,
  width: 28,
  height: 8
}))))));
export default SvgVisualizationSelectionPivotTable;